// Options

export const catalogYearOptions = [
  { value: '2025-01-01', label: '2025 YTD' },
  { value: '2024-12-31', label: '2024 (Full Year)' },
  { value: '2023-12-31', label: '2023 (Full Year)' },
  { value: '2022-12-31', label: '2022 (Full Year)' },
  { value: '2021-12-31', label: '2021 (Full Year)' }
]
